export default __webpack_public_path__ + "static/media/limenaqs3.71d45ee6.jpeg";